import * as React from "react";

import nameof from "ts-nameof.macro";

import { withRouter } from "react-router-dom";
import { NivelContenidosEditModel, TipoAccesoLicencia } from "../models/dataModels";
import { GenericEditState } from "../utils/base/GenericEditState";
import { EditPageBase } from "../utils/base/EditPageBase";
import { IServiceForEdit } from "../utils/base/BaseServices";
import { NivelContenidosService } from "./NivelesContenidosService";
import { RouteHelper } from "../IntranetRouter";
import { Col, FormGroup, Input, Label, Row } from "reactstrap";
import { I18n } from "../utils/I18n";
import { ModelValidation } from "../utils/base/ModelValidation";

import { NivelEducativoDropDown } from "../cursoEscolar/NivelEducativoDropDown";
import { ClientContext } from "../utils/ClientContext";
import { TipoAccesoDropDown } from "../licenciasColegio/TipoAccesoDropDown";
import { ContenidosPicker } from "../contenidos/colegio/Picker";
import { ContenidosColegioService } from "../contenidos/colegio/ContenidosColegioService";

import { Location as HistoryLocation } from "history";

export class NivelContenidoEditComp extends EditPageBase<NivelContenidosEditModel> {

    protected _setPageTitleForNew(): string {
        return "Nuevo"
    }

    protected _setPageTitleForExisting(editModel: NivelContenidosEditModel): string {
        return `Editar ${editModel.nivelEducativo}`;
    }

    protected _createApiService(): IServiceForEdit<NivelContenidosEditModel> {
        return new NivelContenidosService();
    }

    protected _generateForm(): JSX.Element {
        return <React.Fragment>
            <Row>
                <Col md="4">

                    <ContenidosPicker
                        label={I18n.Strings.licenciasContenido.contenido}
                        required={true}
                        itemId={this.state.editModel.contenidoId}
                        itemName={this.state.editModel.contenido}
                        getIdFromItem={(item) => item.id}
                        getNameFromItem={(item) => {
                            return `${item.nombre}`;
                        }}
                        cursoEscolarId={ClientContext.Current.cursoEscolarActivoId}
                        nivelEducativoId={null}
                        mostrarNiveles={true}
                        mostrarSoloColegio={false}
                        incluirNoConfigurados={true}
                        errorMessage={this.state.validationResult.getError(nameof(this.state.editModel.contenidoId))}
                        onSelected={(contenidoId, contenido, item) => {
                            var state = this._cloneStateForSetState();
                            state.editModel.contenidoId = contenidoId;
                            state.editModel.contenido = contenido;
                            // La editorial del contenido acota los tipos de acceso ofrecidos; al
                            // cambiar de contenido, el desplegable se recarga con los de la nueva.
                            state.editModel.editorial = item == null ? null : item.editorial;

                            this.setState(state);
                        }}
                    />

                </Col>
                <Col md="4">
                    <FormGroup>
                        <Label for={nameof(this.state.editModel.nivelEducativo)}>
                            {I18n.Strings.matriculas.nombreClase}
                        </Label>

                        <NivelEducativoDropDown
                            id={nameof(this.state.editModel.nivelEducativoId)}

                            cursoEscolarId={ClientContext.Current.cursoEscolarActivoId}
                            value={this.state.editModel.nivelEducativoId}

                            text={this.state.editModel.nivelEducativo}
                            seleccionClases={false}
                            onChange={(id, nombre) => {
                                var state = this._cloneStateForSetState();
                                state.editModel.nivelEducativoId = id;
                                state.editModel.nivelEducativo = nombre;
                                this.setState(state);
                            }}
                        />

                        {this._errorMessage(nameof(this.state.editModel.nivelEducativoId))}
                    </FormGroup>
                </Col>
                <Col md="4">
                    {/* Los tipos de acceso se limitan a los que soporta el proveedor de la editorial
                        del contenido (mismo criterio que la ficha de contenidos del colegio y las
                        licencias); el valor ya guardado se mantiene aunque no esté en esa lista. */}
                    <FormGroup>
                        <Label for={nameof(this.state.editModel.tipoAccesoPorDefecto)}>
                            {I18n.Strings.nivelesContenidos.tipoAccesoPorDefecto}
                        </Label>
                        <TipoAccesoDropDown
                            emptyText={I18n.Strings.nivelesContenidos.tipoAccesoPorDefecto + "..."}
                            editorial={this.state.editModel.editorial}
                            id={nameof(this.state.editModel.tipoAccesoPorDefecto)}
                            value={this.state.editModel.tipoAccesoPorDefecto}
                            required={true}
                            onChange={(value: string) => {
                                var newState = this._cloneStateForSetState();
                                if (value != '') {
                                    newState.editModel.tipoAccesoPorDefecto = value as TipoAccesoLicencia;
                                }
                                else {
                                    newState.editModel.tipoAccesoPorDefecto = null;
                                }

                                if (newState.editModel.tipoAccesoPorDefecto != TipoAccesoLicencia.NoAccedeMuestraMensaje) {
                                    newState.editModel.mensajeAcceso = "";
                                }

                                this.setState(newState);
                            }}
                        />
                        {this._errorMessage(nameof(this.state.editModel.tipoAccesoPorDefecto))}
                    </FormGroup>
                </ Col>
                <Col md="4">
                    <FormGroup>
                        <Label for={"nivelEducativo" + nameof(this.state.editModel.mostrarAccesoDirecto)}>{I18n.Strings.nivelesContenidos.mostrarAccesoDirecto}</Label>
                        <Input
                            onChange={(evt) => {
                                var state = this._cloneStateForSetState();
                                state.editModel.mostrarAccesoDirecto = evt.target.checked;
                                this.setState(state);
                            }}
                            type="checkbox"
                            style={{ padding: 0 }}
                            className={"form-control"}
                            name={nameof(this.state.editModel.mostrarAccesoDirecto)}
                            id={"nivelEducativo" + nameof(this.state.editModel.mostrarAccesoDirecto)}
                            checked={this.state.editModel.mostrarAccesoDirecto || false}
                        />
                    </FormGroup>
                </Col>
                
                <Col md="6">
                    <FormGroup>
                        <Label for={nameof(this.state.editModel.mensajeAcceso)}>
                            {I18n.Strings.colegiocredenciales.mensajeDeshabilitarAcceso}
                        </Label>
                        <Input
                            onChange={(evt) => {
                                var state = this._cloneStateForSetState();
                                state.editModel.mensajeAcceso = evt.target.value;
                                this.setState(state);
                            }}
                            type="textarea"
                            required={this.state.editModel.tipoAccesoPorDefecto == TipoAccesoLicencia.NoAccedeMuestraMensaje}
                            disabled={this.state.editModel.tipoAccesoPorDefecto != TipoAccesoLicencia.NoAccedeMuestraMensaje}
                            maxLength={500}
                            className={"form-control " + this._errorClass(nameof(this.state.editModel.mensajeAcceso))}
                            name={nameof(this.state.editModel.mensajeAcceso)}
                            id={nameof(this.state.editModel.mensajeAcceso)}
                            value={this.state.editModel.mensajeAcceso || ""}
                        />
                        {this._errorMessage(nameof(this.state.editModel.mensajeAcceso))}
                    </FormGroup>
                </Col>
            </Row>
        </React.Fragment>;
    }

    protected _skipExitPrompt(location: HistoryLocation): boolean {
        if (location.pathname == RouteHelper.editUsuarioColegio(this.state.editModel.id)) {
            return true;
        }
        return super._skipExitPrompt(location);
    }

    protected _getEditUrl(id: number): string {
        return RouteHelper.editNivelContenido(id, this.props.match.params.contenidoId);
    }

    protected _getListUrl(): string {
        return RouteHelper.listNivelesContenidos(this.props.match.params.contenidoId);
    }

    protected _createStateForNew(): Promise<GenericEditState<NivelContenidosEditModel>> {

        var model = new GenericEditState<NivelContenidosEditModel>();
        model.editModel = {
            id: 0,
            colegioId: 0,
            contenido: "",
            contenidoId: null,
            nivelEducativo: "",
            nivelEducativoId: null,
            mostrarAccesoDirecto: true
        } as NivelContenidosEditModel;

        if (this.props.match.params.contenidoId != null) {
            // Migración de Contenidos: el contenidoId de la ruta es el Id del item de catálogo;
            // el nombre se resuelve contra el detalle de contenidos del colegio (el maestro se retiró).
            let contenidosSrv = new ContenidosColegioService();
            let promData = contenidosSrv.getById(this.props.match.params.contenidoId);

            let modelWithDataProm = promData.then(data => {
                model.editModel.contenido = data.nombre;
                model.editModel.contenidoId = data.id;
                // Su editorial acota los tipos de acceso que se pueden elegir.
                model.editModel.editorial = data.editorial;
                return model;
            });

            return modelWithDataProm;
        }

        return Promise.resolve(model);
    }

    protected _validateModelLocal(): ModelValidation {
        let validation = new ModelValidation();

        if (this.state.editModel.nivelEducativoId == null) {
            validation.addError(nameof(this.state.editModel.nivelEducativoId), I18n.Strings.validationErrors.valueRequired(I18n.Strings.nivelesContenidos.nivel));
        }

        if (this.state.editModel.contenidoId == null) {
            validation.addError(nameof(this.state.editModel.contenidoId), I18n.Strings.validationErrors.valueRequired(I18n.Strings.nivelesContenidos.contenido));
        }

        return validation;
    }

}

export const Edit = withRouter(NivelContenidoEditComp)